import { render, staticRenderFns } from "./noise.vue?vue&type=template&id=1ec1df71&scoped=true&"
import script from "./noise.vue?vue&type=script&lang=js&"
export * from "./noise.vue?vue&type=script&lang=js&"
import style0 from "./noise.vue?vue&type=style&index=0&id=1ec1df71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec1df71",
  null
  
)

export default component.exports